import { Tenant } from '../config/tenants';
import { compensaIconsList } from './compensa';
import { interriskIconsList } from './interrisk';
import { tuwIconsList } from './tuw';

export const icons = {
  [Tenant.COMPENSA]: compensaIconsList,
  [Tenant.INTER_RISK]: interriskIconsList,
  [Tenant.TUW]: tuwIconsList,
};
